import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeMedSeq } from '../traitTypes/TraitTypeMedSeq';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
export class TraitRegistryMediaSequence extends TraitRegistryCategory {
    label = 'Alle Mediensequenzen';
    constructor(parent) {
        super(parent);
        super.init();
    }
    mediaSequence = () => new TraitTypeMedSeq({
        multiple: true,
        /*    label: 'Mediensequenz',
        icon: 'fas fa-play-circle',
        aspectsTemplate: {
          core: [
            'sequenceStartPosition',
            'sequenceEndPosition',
            'playbackChannel',
            'playbackVolume',
            'playbackRate',
            'playbackStartConditions',
            'playbackAbortConditions',
            'playbackAbortRunning',
            'playbackAbortQueued'
          ]
        } */
    });
    availableMediaSequence = () => new TraitTypeSelect( /*{
      label: 'Context-Mediensequenz',
      select: ({ at }) =>
        uniq([
          ...Object.keys(at.context.mediaSequenceContext),
          ...mediaLabeler.predefinedLabelKeys.map(k => k + '_auto')
        ]).map(label => [label, mediaLabeler.getDisplayNameForMediaSequenceValue(label)] as [string, string]),
      aspectsTemplate: {
        core: [
          'sequenceStartPosition',
          'sequenceEndPosition',
          'playbackChannel',
          'playbackVolume',
          'playbackRate',
          'playbackStartConditions',
          'playbackAbortConditions',
          'playbackAbortRunning',
          'playbackAbortQueued'
        ]
      }
    }*/);
    /*
    readonly renderInAspect = () =>
      new TraitTypeSelect({
        select: [['stage_inner'], ['stage_outer']],
      });
  */
    showPlayingVideo = () => new TraitTypeSelect({
        multiple: true,
    } /*
        label: 'Zeige spielendes Video',
        select: ({ at }) =>
            uniq([
                ...Object.keys(at.context.mediaSequenceContext).map(sequenceLabel =>
                    SequenceLabel.sequenceToMediumLabel(sequenceLabel)
                ), // remove e.g. _auto
                ...mediaLabeler.predefinedLabelKeys
            ]).map(label => [label, mediaLabeler.getDisplayNameForMediumLabel(label)] as [string, string])
    */);
    availableMediaFile = () => new TraitTypeSelect( /*{
      label: 'Verfügbares MediumLabel',
      select: ({ at }) =>
        uniq([
          ...Object.keys(at.context.mediaSequenceContext).map(sequenceLabel =>
            SequenceLabel.sequenceToMediumLabel(sequenceLabel)
          ), // remove e.g. _auto
          ...mediaLabeler.predefinedLabelKeys
        ]).map(label => [label, mediaLabeler.getDisplayNameForMediumLabel(label)] as [string, string])
    }*/);
    sequenceStartPosition = () => new TraitTypeNumericWithSlider({
        default: 0,
        /*     hidden: true,
        label: 'Startposition',
        init: 0,
        min: 0,
        step: 0.1,
        max: ({ at }) => {
          const atMedSeq = at.aspect.actor as AttachedMedSeqTrait;
          if (!atMedSeq.trait.value || !atMedSeq.getFile.medFile) return 9999;
          const duration = atMedSeq.getFile.medFile ? atMedSeq.getFile.medFile.durationInSeconds : 9999;
          const sequenceEndPosition = at.valueOf.sequenceEndPosition || 9999;
          return Math.min(duration, sequenceEndPosition);
        } */
    });
    sequenceEndPosition = () => new TraitTypeNumericWithSlider({
        default: 9999,
        /*   label: 'Endposition',
        hidden: true,
        init: 99,
        min: ({ at }) => at.valueOf.sequenceStartPosition,
        max: ({ at }) => {
          const atMedSeq = at.aspect.actor as AttachedMedSeqTrait;
          if (!atMedSeq.trait.value || !atMedSeq.getFile.medFile) return 9999;
          return atMedSeq.getFile.medFile.durationInSeconds || 9999;
        },
        step: 0.1 */
    });
    markName = () => new TraitTypeSelect({
        select: [['showQuestionPart']],
    });
}
